import { css } from '@emotion/react'

import { colors } from '../../../../styles/theme'

export default ({ isMinimal }) => css`
  background-color: ${colors.black};
  color: ${colors.silverChalice};

  .link-section {
    border-color: ${colors.shark};

    &-title {
      color: ${colors.white};
    }
  }

  .footer-bottom {
    border-color: ${colors.trout};

    a,
    [tabindex='0'] {
      color: ${colors.silverChalice};

      &:focus {
        color: ${colors.white};
      }

      @media (hover: hover) {
        &:hover {
          color: ${colors.white};
        }
      }
    }

    .item-upsell {
      color: ${colors.honeyGold};
    }
  }

  li:not(:last-of-type)::after {
    background-color: ${isMinimal && colors.trout};
  }

  .copyright-text::before {
    background-color: ${colors.trout};
  }

  .sony-logo path {
    fill: ${colors.silverChalice};
  }
`
